<template>
   <div>
    <Suspense>
        <template #fallback>
            <div>loading</div>
        </template>

        <AsyncPreferences 
              :action="preferenceAction"
              :trigger="preferenceTrigger" 
              @return-value="preferenceReturn"
                    />
    </Suspense>
  </div>

  <ion-page id="offline-page">
    <ion-content >
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleOffline">
        <ion-item>
          <ion-label><h1>Sync & Refresh Off-line Puzzles</h1></ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ puzzleAttemptStatus }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ puzzleDownloadStatus }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ visualizeDownloadStatus }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ allDoneStatus }}</ion-label>
        </ion-item>
        </div>
    </ion-content>
  </ion-page>
</template>
 
<script setup>
 
  import { IonLabel, IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';
  import { doStartupCheck } from '@/composables/startupCheck.js'
 
  import  AsyncPreferences  from '@/components/AsyncPreferences.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { watch, onMounted, onBeforeUnmount, ref } from "vue";
 
  import { useConnectionStore } from '@/stores/connectionStore';
 
  import { useGetData , getLichessData, getChesscomData, 
              generateErrorAlertText } from '@/composables/getData.js'
    import { useWindowSizeStore } from '@/stores/windowSizeStore';
    import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

   const connectionStore = useConnectionStore()
   const isDark = ref(connectionStore.getDarkmode != "light")

   const puzzleAttemptStatus = ref("Waiting to Send Attempts to Server")
   const puzzleDownloadStatus = ref("Waiting for Puzzle Download Refresh")
   const visualizeDownloadStatus = ref("Waiting to Visualized Puzzle Download Refresh")
   const allDoneStatus = ref("")
   
   const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const preferenceTrigger = ref(0)
  const preferenceAction = ref({})

  var preferenceSetCurrentIndex = 0
  var preferenceSetArray = []

  var puzzleAttemptArray = []
  var puzzleAttemptIndex = 0
  var puzzleAttemptCountString = connectionStore.getPuzzleAttemptCount
  var puzzleAttemptCount = parseInt(puzzleAttemptCountString)
  
  const styleOffline = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
  }
 
   doStartupCheck(false,afterStartupCallbackRoutine)
 
   onMounted(() => {
    getSaveAttempts()
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
  })

  function updateStyleObjects(boundaries) {
    styleOffline.value.height = boundaries['offline'].height + "px"
    styleOffline.value.width = boundaries['offline'].width + "px"
    styleOffline.value.top = boundaries['offline'].top + "px"
    styleOffline.value.left = boundaries['offline'].left + "px"
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculateWidthHeights(availableSpace) :
                                      calculateWidthHeights(availableSpace)
    updateStyleObjects(boundaries)
  }

  function calculateWidthHeights(availableSpace) {

    const offlinePositionTop = 0
    const offlinePositionLeft = availableSpace.leftRightIndent
    const offlineHeight = availableSpace.height - offlinePositionTop
    const offlineWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { offline : {
        width : offlineWidth,
        height : offlineHeight,
        left : offlinePositionLeft + availableSpace.leftIndent,
        top : offlinePositionTop+ availableSpace.topIndent
      }

    }
    return (result)
  }

  // preferences are async.  approach will be to build array of actions then call
  //    "sendPrefence()" to start a loop through the array by waiting for the return
  //                     before going to the next one

  function preferenceReturn(action,key,value) {
    //console.log("**************** RETURN FROM PREFERENCES ",action,key,value)

    // if the action is "get" then this is retrieval of the puzzle attempt
    if (action == "get") {
      puzzleAttemptArray.push(value)
      puzzleAttemptIndex++
      if (puzzleAttemptIndex < puzzleAttemptCount) {
        preferenceAction.value = { action : "get", key : "puzzleAttempt" + puzzleAttemptIndex, value : ""}
        preferenceTrigger.value++
      }
      else
        sendAttemptsToServer()
    }
    else {
      if (preferenceSetCurrentIndex < preferenceSetArray.length)
        sendPreference()
      else {
        //console.log("**************** ALL DONE WITH SET")
        visualizeDownloadStatus.value = "Visualized Puzzle Download Refreshed"
        allDoneStatus.value = "*** Offline Puzzle Download Done ***"
      }
    }
  }

  function sendPreference() {
    //console.log("*** offline puzzle ", preferenceAction.value.action,preferenceAction.value.key)
    preferenceAction.value = preferenceSetArray[preferenceSetCurrentIndex]
    preferenceSetCurrentIndex++
    preferenceTrigger.value++

  }

  function processGetOfflineJsonResponse(json) {
    //console.log(" in get offline puzzles callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const puzzle_count = json['puzzle_count']
    const puzzles = json['puzzles']
    const puzzleArray = puzzles.split("\n")

    connectionStore.setPuzzleCount(puzzle_count)
    connectionStore.setPuzzleNext("0")
   
    for (var i=0; i < puzzle_count; i++) {
      preferenceSetArray.push({ action : "set", key : "puzzle" + i, 
                value : puzzleArray[i]})
    }
  
    getOfflinePuzzles(true)
  }
 
  function processGetOfflineVisualizeJsonResponse(json) {
    //console.log(" in get offline visualize puzzles callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const puzzle_count = json['puzzle_count']
    const puzzles = json['puzzles']
    const puzzleArray = puzzles.split("\n")

    connectionStore.setVisualizeCount(puzzle_count)
    connectionStore.setVisualizeNext("0")
 
    for (var i=0; i < puzzle_count; i++) {
      preferenceSetArray.push({ action : "set", key : "visualize" + i, 
          value : puzzleArray[i]})
    }

    // both regular and visualize puzzles are on the "send" array. now loop through them
    sendPreference()
  }

  function getOfflinePuzzles(getVisualized) {     
    
    if (getVisualized) {
      puzzleDownloadStatus.value = "Puzzle Download Refreshed"
      visualizeDownloadStatus.value = "-> Refreshing Visualized Puzzle Download <-"
    }
    else {
      puzzleAttemptStatus.value = "Puzzle Attempts sent to Server"
      puzzleDownloadStatus.value = "-> Refreshing Puzzle Download <-"
    }

    const timeNow = Math.floor(Date.now() / 1000)

    var formData = {
      get_offline : 1,
      do_count : 0,
      device_time : timeNow,
      is_timed :  0,
      is_backup :  (getVisualized) ? "1" : "0",
      timed_color : "pick",
      do_over_puzzleid : 0,
      is_blindfold : 0
    }

    //console.log("before get puzzle post -> ",formData)

    useGetData("get_offline_puzzles.php", formData, 
        (getVisualized) ? processGetOfflineVisualizeJsonResponse : 
                          processGetOfflineJsonResponse)
  }

  function processSaveAttemptsJsonResponse(json) {

    // reset # of puzzle attempts
    connectionStore.setPuzzleAttemptCount("0")
    getOfflinePuzzles(false)

  }

  function getSaveAttempts() {

    puzzleAttemptStatus.value = "-> Sending Puzzle Attempts to Server <-"
    // if no puzzles, zap the count so we don't have to keep checking for null and then get new puzzles
    if (puzzleAttemptCount == 0) {
      connectionStore.setPuzzleAttemptCount("0")
      getOfflinePuzzles(false)
      return
    }

    // queue up the get the first attempt and then let the return the others
    preferenceAction.value = { action : "get", key : "puzzleAttempt" + puzzleAttemptIndex, value : ""}
    preferenceTrigger.value++

  }

  function processSavePuzzleResultJsonResponse (json) {
    //console.log("save puzzle attempts callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    // attempts save, zero out the count and get new puzzles
    connectionStore.setPuzzleAttemptCount("0")
    getOfflinePuzzles(false)
  }

  function sendAttemptsToServer() {

    var catid = []
    var rating = []
    var puzzleid = []
    var half = []
    var best = []
    var quick = []
    var increment = []
    var why = []
    var clean = []
    var blindfold = []
    var do_over = []
    var do_over_rating = []

    //console.log("Send array of attempts to server",puzzleAttemptArray)
    for (var i=0; i < puzzleAttemptArray.length; i++) {
      const one = JSON.parse(puzzleAttemptArray[i])

      // trap any old attempts out there
      if (one.version != "A")
        continue;

      rating.push(one.rating)
      catid.push(one.catid)
      puzzleid.push(one.puzzleid)
      half.push( (one.half != "") ? one.half : "0")
      best.push(one.best)
      quick.push(one.quick)
      increment.push(one.increment)
      why.push(one.why)
      clean.push(one.clean)
      blindfold.push(one.blindfold)
      do_over.push(one.do_over)
      do_over_rating.push(one.do_over_rating)
    }

    if (puzzleid.length == 0) {
      connectionStore.setPuzzleAttemptCount("0")
      getOfflinePuzzles(false)
      return
    }

    // send the stuff to the server
    var formData = {
      ratings : rating.join("\t"),
      catids : catid.join("\t"),
      puzzleids : puzzleid.join("\t"),
      halfs : half.join("\t"),
      bests : best.join("\t"),
      quicks : quick.join("\t"),
      increments : increment.join("\t"),
      whys : why.join("\t"),
      cleans : clean.join("\t"),
      blindfolds : blindfold.join("\t"),
      do_overs : do_over.join("\t"),
      do_over_ratings : do_over_rating.join("\t")
    }
    //console.log("formData",formData)

    useGetData("save_offline_attempts.php", formData, processSavePuzzleResultJsonResponse)

  }

 </script>
 
 <style scoped>

.reptree-container-background-dark {
  background-color: #403726;
  z-index : 0;
}

.reptree-container-background-light {
  background-color : #ebf2f2;
  z-index: 0;
}

.repselector-center-text {
    text-align: center;
    margin-bottom : 10px;
    font-style :italic;
  }

  .repselector-heading-color {
    background: #4c6ca0;
    color : white;
  }

 </style>